export const BRAND = {
  name: "BLEZZINGS",
  fullName: "BLEZZINGS Growth Partners",
  tagline: "Strategy. Execution. Growth.",
  short_pitch:
    "**BLEZZINGS Growth Partners** is a specialist Sales & Marketing transformation firm that helps ambitious businesses accelerate profitable growth through end-to-end strategy and execution.",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_0cc211d0-231a-4662-9c41-f47a4475c7c5/artifacts/liivo4ke_file_000000006d4471faa8dbfa761bdbc56c.png",
  ceoPhoto:
    "/leadership-photo.jpg",
  clientsCollage:
    "https://customer-assets.emergentagent.com/job_execution-results/artifacts/aq5ynq9h_IMG_20260713_213149.jpg",
  heroBg:
    "/photos/hero.jpg",
  aboutBg:
    "/photos/about.jpg",
  contact: {
    phone: "+91 80179 99746",
    phoneHref: "tel:+918017999746",
    email: "khalid@blezzings.co",
    website: "blezzings.co",
    linkedin: "https://www.linkedin.com/in/khalidkamalrumi/",
    linkedinCompany: "https://www.linkedin.com/company/blezzings",
    location: "Whitefield, Bengaluru",
  },
};

export const BRAND_LOGOS = [
  { name: "SAP" },
  { name: "Accenture" },
  { name: "Cognizant" },
  { name: "V-Guard" },
  { name: "Pigeon" },
  { name: "The Indus Valley" },
  { name: "Impex" },
  { name: "MediaOne" },
  { name: "BAKKA" },
];

export const BUSINESSES = [
  {
    slug: "growth-partners",
    name: "BLEZZINGS Growth Partners",
    descriptor: "Sales & Marketing Transformation",
    blurb: "A specialist Sales & Marketing transformation firm helping ambitious businesses accelerate profitable growth through end-to-end strategy and execution.",
    keywords: "Strategy. Execution. Growth.",
    image: "/photos/growth-partners.jpg",
    imageAlt: "Indian sales team reviewing growth charts on a large screen in a bright modern office",
  },
  {
    slug: "academy",
    name: "BLEZZINGS Academy",
    descriptor: "Leadership & Executive Coaching",
    blurb: "Practical learning, executive coaching, leadership development, workshops and courses designed to help people and organisations perform better.",
    keywords: "Learn. Lead. Perform.",
    image: "/photos/academy.jpg",
    imageAlt: "Indian corporate trainer leading a leadership development session with professionals",
  },
  {
    slug: "publications",
    name: "BLEZZINGS Publications",
    descriptor: "Books, Research & Ideas",
    blurb: "Creating and publishing books, research, reports and original thinking that help people understand business, markets, leadership and the world around them.",
    keywords: "Read. Think. Question.",
    image: "/photos/publications.jpg",
    imageAlt: "Indian professional selecting a business book in a sunlit modern bookstore",
  },
  {
    slug: "ventures",
    name: "BLEZZINGS Ventures",
    descriptor: "Investing & Venture Building",
    blurb: "Backing promising founders, investing in businesses with potential and supporting the creation of ventures that can build lasting value.",
    keywords: "Invest. Build. Grow.",
    image: "/photos/ventures.jpg",
    imageAlt: "Indian startup founders pitching to investors in a bright modern office",
  },
  {
    slug: "blezz-talks",
    name: "BLEZZ Talks",
    descriptor: "Conversations, Perspectives & Ideas",
    blurb: "Conversations with leaders, entrepreneurs, experts and thinkers through interviews, podcasts, webinars, talks and other formats.",
    keywords: "Listen. Learn. Think.",
    image: "/photos/blezz-talks.jpg",
    imageAlt: "Indian podcast host and guest recording in a warm professional studio",
  },
  {
    slug: "foundation",
    name: "BLEZZINGS Foundation",
    descriptor: "Social Impact & Philanthropy",
    blurb: "Creating opportunities and supporting initiatives across education, livelihoods, entrepreneurship and community development.",
    keywords: "Create Opportunity. Create Impact.",
    image: "/photos/foundation.jpg",
    imageAlt: "Indian women entrepreneurs in a bright community training workshop",
  },
];

export const CONNECTORS = [
  { title: "Growth", body: "Helping businesses and ventures become stronger, more competitive and more valuable." },
  { title: "Knowledge", body: "Turning experience, research and ideas into insights that can be shared and applied." },
  { title: "People", body: "Developing leaders, professionals, entrepreneurs and capabilities." },
  { title: "Capital", body: "Backing promising ideas, founders and businesses with potential." },
  { title: "Impact", body: "Creating opportunities and contributing to positive, sustainable change." },
];

export const CAPABILITIES = [
  {
    slug: "strategy-commercial-transformation",
    name: "Strategy & Commercial Transformation",
    line: "Business Strategy • Product Portfolio • Pricing • GTM • Channels • Sales",
    image: "/photos/expertise-strategy.jpg",
    imageAlt: "Indian strategy consultants collaborating at a glass planning wall with colorful notes",
    bandImage: "/photos/band-strategy.jpg",
    bandImageAlt: "Senior Indian strategy team working through a go-to-market roadmap on a whiteboard",
    intro: [
      "We help businesses make the strategic choices that drive profitable growth — from where to compete and what to sell, to how to price, go to market and build an effective sales engine.",
      "Our work spans business strategy, portfolio and pricing, go-to-market, channel strategy and sales organisation design. And unlike traditional strategy engagements that often end with recommendations, we stay involved to help turn strategy into execution and measurable commercial outcomes.",
    ],
    subhead: "Business strategies designed to accelerate revenue, profitability and sustainable growth.",
    tagline: "Diagnose. Design. Deliver.",
    metaDescription:
      "Business strategies designed to accelerate revenue, profitability and sustainable growth — across portfolio, pricing, go-to-market, channels and sales.",
    offers: [
      { title: "Product Portfolio Strategy", body: "What to sell, to whom, and why." },
      { title: "Pricing & Promotions", body: "Pricing and sales promotions strategy." },
      { title: "Channel & Distribution", body: "Sales channel and distribution strategy — direct, distributor, marketplace, and hybrid models." },
      { title: "Go-To-Market", body: "Go-to-market strategy for new products, markets, and categories." },
      { title: "Sales Organisation", body: "Sales team structure and incentive design." },
    ],
    whoWeServe: "CXOs and founders who need a business strategy that's rigorous enough to defend in the boardroom — and practical enough to actually run in the market.",
    whyBlezzings: [
      "Strategy firms are excellent at the plan. Where many stop short is the handoff — the plan lands with a team that didn't build it, and something gets lost in translation.",
      "Our strategy work doesn't end at the recommendation. The same team that designs your go-to-market plan also builds the brand that brings it to life and runs the sales engine that delivers it — so nothing gets lost between the boardroom and the market.",
    ],
    closing: "Ready to unlock your next phase of profitable growth?",
    ctaLead: "Whether you need to sharpen your strategy, rethink pricing, strengthen your go-to-market approach or transform sales performance, we can help turn complex growth challenges into clear, executable actions.",
  },
  {
    slug: "market-customer-intelligence",
    name: "Market & Customer Intelligence",
    line: "Customers • Competition • Markets • Research • Insights",
    image: "/photos/expertise-marketing.jpg",
    imageAlt: "Indian team reviewing a colorful market analytics dashboard on a large screen",
    bandImage: "/photos/band-intelligence.jpg",
    bandImageAlt: "Indian market researcher interviewing a shopper with a tablet in a bright retail aisle",
    intro: [
      "Good strategy starts with knowing something true about your customers and your market — not assuming it. We gather insight the way serious research firms do: by observing and talking to real customers, and by rigorously tracking competition and market trends — then we connect that insight directly to the strategy and brand decisions it should inform.",
    ],
    subhead: "Research and intelligence that uncovers market truths and predicts where it is headed.",
    tagline: "Ask. Analyse. Act.",
    metaDescription:
      "Research and intelligence that uncovers market truths — primary and secondary research, competitive intelligence and market trend insights.",
    offers: [
      { title: "Primary Research", body: "Qualitative (interviews, focus groups, ethnographic studies) and quantitative (surveys, structured studies)." },
      { title: "Secondary Research", body: "Market sizing, industry analysis, desk research." },
      { title: "Competitive Intelligence", body: "Competitive intelligence and benchmarking." },
      { title: "Trends & Insights", body: "Market trend tracking, analysis and insights." },
    ],
    whoWeServe: "Business leaders who want decisions grounded in evidence — before a strategy is set, a brand is built, or a campaign goes live.",
    whyBlezzings: [
      "Traditional research firms hand you a report and move on to the next client. We don't stop at the data — because we're often the same team using it to build your strategy or your brand the following week.",
      "That means the questions we ask are shaped by what actually needs deciding, not just what's easy to measure.",
    ],
    closing: "Make better decisions with sharper market and customer insight.",
    ctaLead: "If you need to understand your customers, size an opportunity, evaluate competitors or uncover emerging market shifts, we can help you replace assumptions with evidence and actionable intelligence.",
  },
  {
    slug: "brand-marketing-communications",
    name: "Brand, Marketing & Communications",
    line: "Brand Strategy • Identity • Marketing • Advertising • PR",
    image: "/photos/brand-marketing.jpg",
    imageAlt: "Indian creative team reviewing brand identity boards in a bright design studio",
    bandImage: "/photos/band-brand.jpg",
    bandImageAlt: "Indian marketing team reviewing advertising campaign layouts in a bright creative studio",
    intro: [
      "A brand is a business decision before it's a creative one. We build brand strategy, identity design, and brand architecture grounded in real market insight and business strategy — then bring it to life through an integrated marketing plan, including public relations, built to move the numbers that matter.",
    ],
    subhead: "Brand strategy, identity, and integrated marketing that builds category leaders.",
    tagline: "Position. Design. Amplify.",
    metaDescription:
      "Brand strategy, identity and integrated marketing that builds category leaders — from positioning and design to campaigns and PR.",
    offers: [
      { title: "Brand Strategy", body: "Brand strategy and positioning." },
      { title: "Identity Design", body: "Identity design and visual brand systems." },
      { title: "Brand Architecture", body: "For multi-product and multi-business portfolios." },
      { title: "Integrated Marketing", body: "Integrated marketing communications and campaign planning." },
      { title: "Advertising & Content", body: "Advertising and content strategy." },
      { title: "Creative Production", body: "Creative production across campaigns and brand assets." },
      { title: "Public Relations", body: "Public relations that builds trust and visibility." },
    ],
    whoWeServe: "Businesses building a new brand from scratch, repositioning an existing one, or bringing structure to a growing portfolio of products and sub-brands.",
    whyBlezzings: [
      "Most branding agencies design a beautiful identity and hand it back to you to figure out how to use it. Ours is built on the strategy and insight our own team gathered — and handed straight to the same team running your digital funnel.",
      "The brand isn't a separate project from the growth plan. It's part of it.",
    ],
    closing: "Build a brand customers notice, trust and choose.",
    ctaLead: "From positioning and identity to integrated marketing and communications, we help create brands and marketing strategies that strengthen differentiation, relevance and demand.",
  },
  {
    slug: "digital-commerce",
    name: "Digital & Commerce",
    line: "Performance • Social • SEO • D2C • E-commerce • Quick Commerce • CRM • Loyalty",
    image: "/photos/expertise-execution.jpg",
    imageAlt: "Indian team working at laptops around a long table in a bright office",
    bandImage: "/photos/band-digital.jpg",
    bandImageAlt: "Indian digital marketing team reviewing e-commerce dashboards on large monitors",
    intro: [
      "Digital marketing only works when every part of the funnel is pulling in the same direction — awareness, acquisition, conversion, and retention, built as one system instead of separate campaigns run by separate teams.",
      "We run the full funnel: social and influencer marketing, D2C and e-commerce sales, organic and SEO, and retention through marketing automation and loyalty programmes.",
    ],
    subhead: "Full-funnel digital execution, from discovery to loyalty.",
    tagline: "Reach. Convert. Retain.",
    metaDescription:
      "Full-funnel digital execution, from discovery to loyalty — social, SEO, D2C, e-commerce, quick commerce, CRM and retention.",
    offers: [
      { title: "Social & Influencer", body: "Social media marketing and influencer marketing." },
      { title: "D2C & E-Commerce", body: "Sales across Amazon, Flipkart, quick commerce, and your own website." },
      { title: "Organic & SEO", body: "Organic growth and SEO." },
      { title: "Retention & Loyalty", body: "Retention marketing through marketing automation and loyalty programmes." },
      { title: "Full-Funnel & CRM", body: "Full-funnel digital sales strategy and CRM." },
    ],
    whoWeServe: "Businesses that need digital execution accountable to actual revenue — not just reach, impressions, or engagement metrics.",
    whyBlezzings: [
      "Performance marketing agencies are built to run campaigns. We're built to run growth — because the same team that shapes your brand and your strategy is the one deciding what the digital funnel should actually say and sell.",
      "That alignment is usually the difference between a campaign that performs well and one that actually grows the business.",
    ],
    closing: "Turn digital attention into customers, revenue and repeat business.",
    ctaLead: "Whether you want to acquire customers more efficiently, accelerate e-commerce, strengthen your D2C business or improve retention, we can help build a connected digital growth engine across the entire customer funnel.",
  },
];

export const IMPACT = [
  {
    key: "cookware",
    metric: "₹150Cr+",
    metricSub: "annual run-rate",
    category: "D2C · Cookware",
    title: "Built India's No.1 Healthy Cookware Brand",
    body: "Built a differentiated, profitable D2C brand from the ground up. Grew sales 5×, broke into the Top 3 Amazon bestsellers and lifted marketing ROI by 28%.",
    highlights: ["5× sales growth", "Top 3 on Amazon", "+28% marketing ROI"],
  },
  {
    key: "battery",
    metric: "10 yrs",
    metricSub: "to first profit",
    category: "Consumer Durables",
    title: "Turned around the Inverter Battery category",
    body: "Led the P&L turnaround of the Inverter Battery business at a leading consumer durables brand — making it profitable for the first time in a decade since inception.",
    highlights: ["Profitable category", "P&L transformation", "10-year turnaround"],
  },
  {
    key: "ecommerce",
    metric: "-6% → +3%",
    metricSub: "EBITDA swing",
    category: "Consumer Appliances\nE-commerce",
    title: "Turned e-commerce from loss to profit",
    body: "Rebuilt the e-commerce channel at a consumer appliances brand — moving it from -6% to +3% EBITDA while clocking a 66% jump in sales.",
    highlights: ["9-point EBITDA lift", "66% sales growth", "Channel restructure"],
  },
  {
    key: "pizza",
    metric: "4,000+",
    metricSub: "stores impacted",
    category: "QSR · Global Transformation",
    title: "Digital transformation at world's 3rd largest pizza chain",
    body: "Orchestrated digital transformation at a Fortune-listed US-based global pizza chain — positively impacting 4,000+ corporate and franchise stores across markets.",
    highlights: ["Fortune 500 client", "Global rollout", "Corporate + franchise scale"],
  },
];

export const AWARDS = [
  {
    title: "Top 100 CMOs in India",
    body: "Startuplanes",
    year: "2023",
  },
  {
    title: "40 Under 40 Startup Leader",
    body: "International Brand Equity",
    year: "2023",
  },
  {
    title: "30 Marketing Mavericks — Rising Stars Transforming India's Startup Ecosystem",
    body: "Indian Startup Times",
    year: "2024",
  },
  {
    title: "Cognizant Consulting Achiever — 4 consecutive years",
    body: "Cognizant",
    year: "2013–2016",
  },
  {
    title: "Best Use of MarTech — E-Commerce",
    body: "e4m Martech India Award",
    year: "2024",
  },
];

export const METRICS = [
  { value: "16+", label: "Years of business transformation" },
  { value: "3", label: "Businesses turned profitable" },
  { value: "5+", label: "Countries served, teams led globally" },
  { value: "Fortune 500", label: "MNCs, listed cos. & startups" },
];
